'use strict';

var _require = require('../constants/post'),
    POST_CUSTOM_EXCERPT_MAX_LENGTH = _require.POST_CUSTOM_EXCERPT_MAX_LENGTH;

var ELLIPSIS = '...';
var CONTENT_TEXT_LENGTH_WITHIN_EXCERPT = POST_CUSTOM_EXCERPT_MAX_LENGTH - ELLIPSIS.length;
var REGEXP = new RegExp('^(.{' + CONTENT_TEXT_LENGTH_WITHIN_EXCERPT + '}[w]*).*');

function getExcerptFromContentText(contentText) {
  if (!contentText) {
    return '';
  }
  var cleanContent = contentText.replace(/ *\n */g, ' ').trim();
  if (cleanContent.length <= POST_CUSTOM_EXCERPT_MAX_LENGTH) {
    return cleanContent;
  }
  return cleanContent.replace(REGEXP, '$1') + ELLIPSIS;
}

module.exports = getExcerptFromContentText;